module.exports = __webpack_public_path__ + "img/Worth_Logo.7c1bbed5.png";